import { ProductNomination } from 'components/award/product-nomination/ProductNomination'
import { INIT_STATE, INITIAL_DATA_FILTER } from 'configs/award/configTableProductNomination'
import { ACTION_TYPE } from 'constants/constant'
import { useValidation } from 'hooks/useValidation'
import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { API_AWARD } from 'services/apiAward'
import { useFetch } from 'services/useFetch'
import { getAllQueryParams, getObjectName, setQueryParams, uploadFileToS3 } from 'utils/utils'
import { Alert } from 'avo-ui'

export const ProductNominationContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [productNominationDetail, setProductNominationDetail] = useState(INIT_STATE)
    const [selectedIds, setSelectedIds] = useState([])
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const { fetching: getProductList, data: dataProductList, isLoading } = useFetch(API_AWARD.PRODUCT_LIST)
    const { fetching: createProduct, isLoading: isCreating } = useFetch(API_AWARD.PRODUCT_CREATE)
    const { fetching: updateProduct, isLoading: isUpdating } = useFetch(API_AWARD.PRODUCT_UPDATE)
    const { fetching: deleteProduct, isLoading: isDeleting } = useFetch(API_AWARD.PRODUCT_DELETE)
    const { fetching: getURLImage } = useFetch(API_AWARD.URL_AWARD_IMAGE)
    const { isFormValid } = useValidation({ form: productNominationDetail })
    const [modal, setModal] = useState({
        delete: false,
        form: false,
    })

    useEffect(() => {
        fetchProductList(query)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchProductList = (item = { ...query }) => {
        getProductList(item)
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onHideForm = () => {
        setShowModal({ form: false })
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setProductNominationDetail({ ...productNominationDetail, [name]: value })
    }

    const onActionRow = ({ item, actionType }) => {
        switch (actionType) {
            case ACTION_TYPE.CREATE:
                setProductNominationDetail(INIT_STATE)
                setShowModal({ form: true })
                break
            case ACTION_TYPE.EDIT:
                setProductNominationDetail(item)
                setShowModal({ form: true })
                break
            default:
                setProductNominationDetail(item)
                setShowModal({ delete: true })
        }
    }

    const onDelete = async () => {
        await deleteProduct({ product_ids: productNominationDetail?.id ? [productNominationDetail?.id] : selectedIds })
        setIsResetSelectedItem(!isResetSelectedItem)
        setShowAlert('Product Nomination Deleted !', { delete: false })
        query?.page === '1' ? fetchProductList(INITIAL_DATA_FILTER) : onChangeQuery(INITIAL_DATA_FILTER)
    }

    const handleUploadImage = async (file) => {
        const s3Urls = await getURLImage({ files: [file.name] })
        await uploadFileToS3(s3Urls?.data?.[0], file.file)
        return `${s3Urls?.data?.[0]?.url}${s3Urls?.data?.[0]?.fields?.key}`
    }

    const onSubmit = async () => {
        const isUpdate = !!productNominationDetail.id
        const payload = {
            ...productNominationDetail,
            image_url: productNominationDetail?.image_url?.file
                ? await handleUploadImage(productNominationDetail?.image_url)
                : productNominationDetail?.image_url,
        }

        if (isUpdate) {
            await updateProduct(payload, productNominationDetail.id)
            fetchProductList(query)
        } else {
            await createProduct(payload)
            query?.page === '1' ? fetchProductList(INITIAL_DATA_FILTER) : onChangeQuery(INITIAL_DATA_FILTER)
        }
        setShowAlert(`Product Nomination ${isUpdate ? 'Updated' : 'Created'}!`, { form: false })
    }

    const props = {
        dataList: dataProductList?.data,
        productNominationDetail,
        modal,
        setShowModal,
        query,
        onChangeQuery,
        isFormValid,
        selectedIds,
        setSelectedIds,
        onSelectItemHandler,
        onActionRow,
        onChangeForm,
        onHideForm,
        onSubmit,
        onDelete,
        isLoading,
        isDeleting,
        isCreating,
        isUpdating,
        isResetSelectedItem,
    }

    return <ProductNomination {...props} />
}
